<template>
  <div :style="`width: ${isCollapse ? '64px' : '100%'}; ${isCollapse ? 'transition: width 0.3s ease;' : 'transition: width 0.3s ease 0.3s;'} display: flex; align-items: center; position: relative;`">
    <el-menu
      :default-active="$route.name"
      :collapse="isCollapse"
      style="position: relative;"
      class="el-menu-vertical-demo"
      @select="handleSelect"
    >
      <el-menu-item
        v-can="['ntax.view']"
        index="ntax-invoices"
      >
        <i class="el-icon-document"></i>
        <span>Számlák</span>
      </el-menu-item>
      <el-menu-item
        v-can="['ntax.view']"
        index="ntax-partners"
      >
        <i class="el-icon-user"></i>
        <span>Partnerek</span>
      </el-menu-item>
    </el-menu>
    <el-button
      :icon="isCollapse ? 'el-icon-arrow-left' : 'el-icon-arrow-left'"
      circle
      size="mini"
      :style="`position: absolute; right: 0; transform: translateX(50%) translateY(-50%); top: 50%; ${isCollapse ? 'transform: rotateZ(180deg) translate(-50%, 50%);' : ''} ${isCollapse ? 'transition: 0.3s;' : 'transition: 0.3s ease 0.3s;'} `"
      @click="handleCollapse"
    ></el-button>
  </div>
</template>
<script>
  export default {
    computed: {
      isCollapse() {
        return this.$store.getters['sidebar/isNtaxUserSidebarCollapse'];
      },
      active() {
        const queryString = Object.keys(this.$route.query).map((key) => key + '=' + this.$route.query[key]).join('&')
        return this.$route.name + (queryString ? '?' + queryString : '');
      },
    },
    methods: {
      handleSelect(page) {
        if (page === 'ntax-invoices') {
          return this.$router.push('/' + page + '?ntax_exported=0');
        } else {
          return this.$router.push('/' + page);
        }
      },
      handleCollapse() {
        if(this.isCollapse) {
          this.$store.commit('sidebar/setIsNtaxUserSidebarCollapse', false);
        } else {
          this.$store.commit('sidebar/setIsNtaxUserSidebarCollapse', true) ;
        }
      }
    }
  };
</script>

<style scoped>
  .el-menu-vertical-demo > .el-menu-item.is-active {
    border-right: 2px solid #409EFF;
    transition: 0.3s;
    background: #ecf5ff;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100%;
  }
</style>
